import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import { useWindowSize } from '@react-hook/window-size';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import {
  viewerPhotoDocumentsRelabelInit,
  viewerPhotoDocumentsRelabel,
} from '../../actions/Viewer/ViewerActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
} from './PhotoDocumentsRelabel.style';
// import { Breakpoints } from '../../assets/Variables.style';

const PhotoDocumentsRelabelInner = ({
  ids,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const dispatch = useDispatch();
  const firebaseStore = useSelector((state) => state.firebase);
  const { profile } = firebaseStore;
  const isProfileCompany = profile.company && profile.company.id ? true : false;

  const viewerPhotoDocumentsRelabelStore = useSelector(
    (state) => state.viewerPhotoDocumentsRelabelStore
  );
  const {
    isLoading,
    isSuccess,
    isError,
    error,
  } = viewerPhotoDocumentsRelabelStore;

  const onSubmit = (e) => {
    e.preventDefault();
    if (isProfileCompany) {
      dispatch(viewerPhotoDocumentsRelabel({ ids }));
    }
  };

  useEffect(() => {
    dispatch(viewerPhotoDocumentsRelabelInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleProcess(isLoading ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, isError]);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.photoDocumentsRelabel.wrapper}>
        <Header theme={theme.photoDocumentsRelabel.header}>
          <Title theme={theme.photoDocumentsRelabel.title}>
            {intl.formatMessage({
              id: 'RELABEL_PHOTO_DOCUMENTS.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.photoDocumentRelabel.text.default}>
                {intl.formatMessage({
                  id: `RELABEL_PHOTO_DOCUMENTS.TEXT.THE_PHOTO_DOCUMENTS_HAVE_BEEN_SUCCESSFULLY_RELABELED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => {
              handleClose();
            }}
          >
            {intl.formatMessage({ id: 'RELABEL_PHOTO_DOCUMENTS.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  return (
    <>
      {isSuccess ? (
        renderSuccessPanel()
      ) : (
        <Form onSubmit={onSubmit}>
          <Wrapper theme={theme.photoDocumentsRelabel.wrapper}>
            <Header theme={theme.photoDocumentsRelabel.header}>
              <Title theme={theme.photoDocumentsRelabel.title}>
                {intl.formatMessage({
                  id: 'RELABEL_PHOTO_DOCUMENTS.RELABEL_PHOTO_DOCUMENTS',
                })}
              </Title>
            </Header>
            <Content>
              <Box>
                <Textbox center>
                  <Text theme={theme.photoDocumentRelabel.text.default}>
                    {intl.formatMessage({
                      id: `RELABEL_PHOTO_DOCUMENTS.TEXT.ARE_YOU_SURE_WANT_TO_RELABEL_PHOTO_DOCUMENTS`,
                    })}
                    <br />
                    {intl.formatMessage({
                      id: `RELABEL_PHOTO_DOCUMENTS.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                    })}
                  </Text>
                </Textbox>
              </Box>
            </Content>
            {isError ? (
              <Textbox>
                <Text theme={theme.photoDocumentsRelabel.text.error}>
                  {intl.formatMessage({
                    id: `RELABEL_PHOTO_DOCUMENTS.TEXT.ERROR.${error}`,
                    defaultMessage: error,
                  })}
                </Text>
              </Textbox>
            ) : (
              ''
            )}
            <Footer>
              <Button
                type='button'
                theme={theme.button.alt}
                disabled={isLoading}
                onClick={() => {
                  handleClose();
                }}
              >
                {intl.formatMessage({ id: 'RELABEL_PHOTO_DOCUMENTS.CANCEL' })}
              </Button>
              <Button theme={theme.button.default} disabled={isLoading}>
                {isLoading
                  ? intl.formatMessage({
                      id: 'RELABEL_PHOTO_DOCUMENTS.PLEASE_WAIT',
                    })
                  : intl.formatMessage({
                      id: `RELABEL_PHOTO_DOCUMENTS.RELABEL`,
                    })}
              </Button>
            </Footer>
          </Wrapper>
        </Form>
      )}
    </>
  );
};

const PhotoDocumentsRelabel = ({
  ids,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  // const [width] = useWindowSize();
  return (
    <Modal
      handleClose={handleClose}
      // fullscreen={width <= Breakpoints.md ? true : false}
    >
      <PhotoDocumentsRelabelInner
        ids={ids}
        handleClose={handleClose}
        handleProcess={handleProcess}
      />
    </Modal>
  );
};

PhotoDocumentsRelabelInner.propTypes = {
  ids: PropTypes.array,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

PhotoDocumentsRelabel.propTypes = {
  ids: PropTypes.array,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

export default PhotoDocumentsRelabel;
